import classes from "./CountrySelect.module.css";
import CountryCodeList from '../../SignUp/CountryCodeList.json';
import { useState, useEffect } from "react";
import DropdownModal from "./DropdownModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { updateUserCurrency } from "../../../Store/actions/UsersActions";

const CountrySelect = ({showModal,setShowModal}) => {

  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch()

  const [selectedCountry, setSelectedCountry] = useState({
    "name": "United States",
    "dial_code": "+1",
    "code": "US",
    "currency": "USD"
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);

  useEffect(() => {
    if (!CountryCodeList?.countryCode) return;
  
    const query = searchQuery.toLowerCase();
  
    if (!query) {
      setFilteredCountries(CountryCodeList.countryCode); // Reset when empty
      return;
    }
  
    let exactMatches = [];
    let partialMatches = [];
  
    CountryCodeList.countryCode.forEach(item => {
      const nameMatch = item.name.toLowerCase() === query;
      const codeMatch = item.code.toLowerCase() === query;
      const currencyMatch = item.currency.toLowerCase() === query;
  
      if (nameMatch || codeMatch || currencyMatch) {
        exactMatches.push(item);
      } else if (
        item.name.toLowerCase().includes(query) ||
        item.code.toLowerCase().includes(query) ||
        item.currency.toLowerCase().includes(query)
      ) {
        partialMatches.push(item);
      }
    });
  
    const sortedResults = [...exactMatches, ...partialMatches];
  
    setFilteredCountries(sortedResults.length > 0 ? sortedResults : []);
  }, [searchQuery]);
  
  useEffect(() => {
    if(currentUser?.id) {
      const selectedCurrencyCode = currentUser?.preferredCurrency;
      const selectedCountryCode = currentUser?.preferredCountry;

      const selectedCountry = CountryCodeList?.countryCode?.find(item => 
        (item.currency === selectedCurrencyCode && item.code === selectedCountryCode)
      );

      if(selectedCountry) {
        setSelectedCountry(selectedCountry)
      }
    } else {
    const storedCountry = localStorage.getItem("selectedCountry");
    
    if (storedCountry) {
        const parsedCountry = JSON.parse(storedCountry);
        setSelectedCountry(parsedCountry);
    }
  }
  },[currentUser])

  const handleToggleDropdown = (e) => {
    // e.stopPropagation(); // Stop propagation when opening dropdown
    setShowModal(!showModal);
  };

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    if(currentUser?.id) {
      if(country?.currency && (currentUser?.preferredCountry !== country?.currency && currentUser?.preferredCountry !== country?.code)) {
        updateUserCurrency(country?.currency,country?.code,dispatch);
      }
    } else {
      localStorage.setItem("selectedCountry", JSON.stringify(country))
      localStorage.removeItem("guestCart");
      window.location.reload()
    }
  }

  return (
    <div className={classes.wrapper}>
      <div 
        className={classes.selected} 
        onClick={handleToggleDropdown}
      >
        {selectedCountry ? (
          <div style={{display:"flex",alignItems:"center",gap:"1.5rem"}}>
            <div className={classes.selectedCountry}>
              <i className={`${classes.flag} ${classes[`flag-16`]} ${classes[`flag-${selectedCountry.code.toLowerCase()}`]}`} />
              <span>{selectedCountry.code}</span>
            </div>
            <FontAwesomeIcon icon={faAngleDown} />
          </div>
        ) : (
          <span>Select a country</span>
        )}
      </div>

      {showModal && (
        <DropdownModal 
          filteredCountries={filteredCountries} 
          searchQuery={searchQuery} 
          setSearchQuery={setSearchQuery} 
          setSelectedCountry={(country) => {
            handleSelectCountry(country);
          }} 
          selectedCountry={selectedCountry}
          setShowModal={setShowModal}
          onClose={() => setShowModal(false)} 
        />
      )}
    </div>
  );
};

export default CountrySelect;